import { pinYinMatch } from 'src/sub-tree/common/src/base/utils';
import { getAllDepartment } from 'api/application/department';

/**
 * 部门计算函数
 * 后续逐渐向core迁移
 */
export class SelectDepartmentService {
  // eslint-disable-next-line no-undef
  TREE = {};
  // eslint-disable-next-line no-undef
  rootDeep = undefined;
  // eslint-disable-next-line no-undef
  searchCache = {};
  // eslint-disable-next-line no-undef
  oidToDeepMap = {}; // 根据oid快速寻找tree的哪一层，原本用pathDepth寻找，但是某次修改之后，没有父部门的节点会挂在根结点下
  // eslint-disable-next-line no-undef
  searchQueue = [];
  // eslint-disable-next-line no-undef
  data = [];

  constructor({ labelKey, codeKey }) {
    this.labelKey = labelKey;
    this.codeKey = codeKey;
  }
  getListData(key, params) {
    const { companyOID, applicantOID, keyword } = params;
    return getAllDepartment(companyOID, applicantOID, keyword);
  }

  initTree(data) {
    const { TREE, oidToDeepMap } = this;
    data.sort((a, b) => {
      if (a.pathDepth !== b.pathDepth) return a.pathDepth - b.pathDepth;
      else return a.departmentCode - b.departmentCode;
    });
    this.rootDeep === undefined && (this.rootDeep = data[0] && data[0].pathDepth);

    let dataLength = data.length;
    for (let i = 0; i < dataLength; i++) {
      let department = data[i];
      department.path = (department.path || '').trim().replace(/[|]/g, '  $&  '); //前后插入空格
      // if (department.hasChildrenDepartments) {
      //   department.childrenList = [];
      // }
      department.childrenList = [];

      let parentOID = department.parentDepartmentOID,
        targetDeep = department.pathDepth, // 将要挂载的层级
        deepTree,
        rootDeepTree = TREE['deep' + this.rootDeep];

      // 记录oid与层级映射
      oidToDeepMap[department.departmentOID] = targetDeep;

      if (department.status === 102) {
        // 无相应父部门或停用的部门标记，避免搜索时展示
        department.hide = true;
      } else {
        if (parentOID) {
          let parentDeep = oidToDeepMap[parentOID];
          let parentDepartment = TREE['deep' + parentDeep] && TREE['deep' + parentDeep][parentOID];

          // 找到父部门则挂到父部门下，父部门有可能是挂在根结点下的，所以通过oidToDeepMap取父部门的层级
          if (parentDepartment) {
            department.parentDepartment = parentDepartment;
            parentDepartment.childrenList && parentDepartment.childrenList.push(department);

            targetDeep = oidToDeepMap[parentDepartment.departmentOID] + 1;
            oidToDeepMap[department.departmentOID] = targetDeep;
            deepTree = TREE['deep' + targetDeep];
            if (deepTree) {
              deepTree[department.departmentOID] = department;
            } else {
              TREE['deep' + targetDeep] = {
                [department.departmentOID]: department,
              };
            }
            continue;
          }
        }

        // 若无父部门OID或者未在树中找到父部门，则挂到根结点下
        oidToDeepMap[department.departmentOID] = this.rootDeep;
        if (rootDeepTree) {
          rootDeepTree[department.departmentOID] = department;
        } else {
          TREE['deep' + this.rootDeep] = {
            [department.departmentOID]: department,
          };
        }
      }
    }
    this.data = data;
  }

  getTargetNode(target) {
    const { TREE, oidToDeepMap } = this;
    if (target && target.status === 101) {
      let { departmentOID } = target;
      let departmentsList = [];
      let targetDeep = oidToDeepMap[departmentOID];
      if (TREE['deep' + targetDeep] && TREE['deep' + targetDeep][departmentOID]) {
        // 去map记录的节点层级找
        departmentsList = TREE['deep' + targetDeep][departmentOID];
      }
      return {
        childrenList: Object.keys(departmentsList).map((OID) => {
          return departmentsList[OID];
        }),
      };
    } else {
      return {
        childrenList: Object.keys(TREE['deep' + this.rootDeep] || {}).map((OID) => {
          return (TREE['deep' + this.rootDeep] || {})[OID];
        }),
      };
    }
  }

  getBreadCrumbPath(department) {
    const { TREE, oidToDeepMap } = this;
    if (!department || department.status === 102) return [];
    let { departmentOID } = department,
      targetDeep = oidToDeepMap[departmentOID],
      pathArray = [],
      currentDep = department,
      parentDep;
    if (currentDep.parentDepartmentOID === undefined || !currentDep.parentDepartmentOID) {
      if (!TREE['deep' + targetDeep]) {
        return [];
      }
      currentDep = TREE['deep' + targetDeep][departmentOID];
    }
    while (targetDeep > 1) {
      let parentDepOID = currentDep.parentDepartmentOID;
      if (!parentDepOID) {
        break;
      }
      parentDep = TREE['deep' + --targetDeep][parentDepOID];
      pathArray.unshift((currentDep = parentDep));
    }
    return pathArray;
  }
  getSearchBreadCrumbPath(item, treeRootPath) {
    let arr = [item];
    const getPath = (item) => {
      if (item.parentDepartmentOID) {
        arr.unshift(item.parentDepartment);
        getPath(item.parentDepartment);
      } else {
        return;
      }
    };
    getPath(item);
    arr.unshift(treeRootPath);
    arr = item.departmentOID ? arr : [treeRootPath];
    return arr;
  }
  findEntityDepartment(treeList) {
    let result = false;
    if (treeList && treeList.length > 0) {
      treeList.forEach((nodeItem) => {
        if (nodeItem.isEntity !== false || !nodeItem.hideDepartment) {
          result = true;
          return result;
        }
      });
    } else {
      result = false;
    }
    return result;
  }
  //如果该部门是实体部门，并且不是叶子部门，并且开启只能选叶子部门的配置，并且下面全是虚拟部门
  //深度优先遍历
  markHideVirtualDepartment(treeList) {
    if (!treeList) return;
    treeList.forEach((nodeItem) => {
      this.markHideVirtualDepartment(nodeItem.childrenList);
      //虚拟部门才做处理
      let hasEntity = this.findEntityDepartment(nodeItem.childrenList);
      //不是虚拟部门，直接检查
      if (nodeItem.isEntity === false) {
        nodeItem.hideDepartment = !hasEntity;
      }
    });
  }
  markHasChildrenDepartments(treeList) {
    if (!treeList) return;
    treeList.forEach((nodeItem) => {
      //虚拟部门才做处理
      if (nodeItem.hasChildrenDepartments) {
        let flag = true;
        nodeItem.childrenList.forEach((child) => {
          if (!child.hideDepartment) {
            flag = false;
          }
        });
        nodeItem.hideChildrenDepartments = flag;
        this.markHasChildrenDepartments(nodeItem.childrenList);
      }
    });
  }
  filterList(treeList) {
    this.markHideVirtualDepartment(treeList);
  }

  // 多关键词模糊搜索，每个关键词都调用pinYinMatch方法进行检测
  checkMultiKeys(matchItem, keyword, searchKeys) {
    // 过滤多空格
    const list = keyword.split(' ').filter((item) => !!item);
    // if(matchItem.name==='测试二级部门'){
    //   debugger
    // }
    let hasName = list.some((item) => {
      const { match } = pinYinMatch(matchItem.name || '', item);
      if (match) {
        return true;
      }
      return false;
    });
    searchKeys.forEach((key) => {
      let flag = list.every((item) => {
        const { match, matchWord = '' } = pinYinMatch(matchItem[key] || '', item);
        if (match) {
          !matchItem.matchWord && (matchItem.matchWord = {});
          matchItem.matchWord[key] += `${matchWord || ''} `;
          return true;
        }
        return false;
      });
      if (!flag) {
        matchItem.matchWord[key] = '';
        !matchItem.weight && (matchItem.weight = 0);
      } else {
        if (key === 'path') {
          if (hasName) {
            matchItem.weight += 1;
          }
        } else {
          matchItem.weight += 1;
        }
      }
    });
    // if (matchItem.weight) {
    //   matchItem.matchWord = matchItem.matchWord.trim().split(' ').join('|');
    // }
    let keys = Object.keys(matchItem.matchWord);
    keys.forEach((key) => {
      matchItem.matchWord[key] = matchItem.matchWord[key].trim().split(' ').join('|');
    });
    return matchItem;
  }

  search(keyword) {
    const { searchCache, searchQueue, data } = this;
    let lowerKeyword = keyword.toLowerCase();
    if (searchCache[lowerKeyword] && searchCache[lowerKeyword].completed) return searchCache[lowerKeyword].result;

    let timeStamp = new Date().getTime(), // 用于中断前一次搜索
      cache,
      department,
      index = 0,
      length = data.length;

    if (searchQueue.length) {
      searchQueue.shift();
    }
    searchQueue.push(timeStamp);

    if (!searchCache[lowerKeyword]) {
      searchCache[lowerKeyword] = {
        completed: false,
        result: [],
        startIndex: undefined,
      };
    }

    cache = searchCache[lowerKeyword];

    if (cache.startIndex !== undefined) {
      index = cache.startIndex;
    }
    for (; index < length; index++) {
      department = data[index];
      if (searchQueue[0] !== timeStamp) {
        cache.startIndex = index;
        break;
      }
      // 拼音搜索
      const searchKeys = ['name', 'path', 'custDeptNumber']; // 搜索匹配的key，名称为name，全路径为path
      department.weight = 0;
      department.matchWord = {
        name: '',
        path: '',
        custDeptNumber: '',
      };
      if (lowerKeyword.includes(' ')) {
        this.checkMultiKeys(department, lowerKeyword, searchKeys);
      } else {
        const { match, matchWord } = pinYinMatch(department, lowerKeyword, ['name', 'custDeptNumber']);
        if (match) {
          department.weight = 1;
          department.matchWord = matchWord;
        }
      }
      if (department.weight && !department.hide) {
        searchCache[lowerKeyword].result.push(department);
      }
      if (index === length - 1) {
        cache.completed = true;
      }
    }

    return searchCache[lowerKeyword].result.sort((a, b) => b.weight - a.weight);
  }

  destroy() {
    this.TREE = {};
    this.rootDeep = undefined;
    this.searchCache = {};
    this.oidToDeepMap = {};
  }
}
export const departmentBatchHighLightWord = ({ key, keyword, department }) => {
  const extendDepartmentName = (keyword, reg, departmentName) => {
    //处理xss漏洞
    let departmentNameHtml = (departmentName || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    // departmentNameHtml.replace(' ','&nbsp;');
    if (departmentNameHtml && departmentNameHtml.length > 80) {
      let firstIndex = departmentName.toLowerCase().indexOf(keyword);

      if (firstIndex >= 60) {
        departmentNameHtml = '...' + departmentNameHtml.substring(firstIndex - 40, 1000);
      }
    }
    // console.log(`departmentNameHtml`,departmentNameHtml);
    return departmentNameHtml.replace(new RegExp(reg, 'ig'), '<span style=\'color:var(--theme-main)\'>$&</span>');
  };
  return department.weight && !department.hide
    ? extendDepartmentName(keyword, department.matchWord[key], department[key])
    : (department[key] || '').replace(new RegExp(department[key], 'ig'), '<span>$&</span>');
};
